import { render, staticRenderFns } from "./development.vue?vue&type=template&id=d02fa8b4&scoped=true&"
import script from "./development.vue?vue&type=script&lang=js&"
export * from "./development.vue?vue&type=script&lang=js&"
import style0 from "./development.vue?vue&type=style&index=0&id=d02fa8b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02fa8b4",
  null
  
)

export default component.exports